define('formkit/view/block/answer.form.object.collection.view',['require','exports','module','underscore','../form.object/form.object.collections.by.section.collection.view','../form.object/form.object.collection.view','../form.object/answer.form.object.view','../../behavior/progressively.disclose.on.displayed.behavior'],function(require, exports, module) {
  var _                                            = require('underscore');
  var FormObjectCollectionsBySectionCollectionView = require('../form.object/form.object.collections.by.section.collection.view');
  var FormObjectCollectionView                     = require('../form.object/form.object.collection.view');
  var AnswerFormObjectView                         = require('../form.object/answer.form.object.view');
  var ProgressivelyDiscloseOnDisplayedBehavior     = require('../../behavior/progressively.disclose.on.displayed.behavior');


  var AnswerFormObjectCollectionBlockView = FormObjectCollectionsBySectionCollectionView.extend({

    childView: FormObjectCollectionView.extend({
      childView: AnswerFormObjectView.extend({
        behaviors: {
          ProgressivelyDiscloseOnDisplayedBehavior: {
            behaviorClass: ProgressivelyDiscloseOnDisplayedBehavior
          }
        }
      })
    }),

    initialize: function() {
      FormObjectCollectionsBySectionCollectionView.prototype.initialize.apply(this, arguments);

      if (this.form) {
        this.collection = this.form.getTemplateModel().get('children');
      }
    },
  });
  module.exports = AnswerFormObjectCollectionBlockView;
});

